/**
 * Gender adjacency validation.
 * Uses neighbor map when provided; falls back to odd/even for legacy layouts.
 */
export default function validateSeatSelectionNew(
  type,
  selected,
  reservedSeatsByFemale,
  reservedSeatsByMale,
  adjacencyMap = null
) {
  const selectedSet = new Set(selected.map(String));

  if (adjacencyMap && Object.keys(adjacencyMap).length > 0) {
    const opposite =
      type === "male"
        ? (reservedSeatsByFemale || []).map(String)
        : (reservedSeatsByMale || []).map(String);

    for (const reservedNum of opposite) {
      for (const neighbor of adjacencyMap[reservedNum] || []) {
        if (selectedSet.has(String(neighbor))) return false;
      }
    }
    return true;
  }

  if (type === "male") {
    for (const item of reservedSeatsByFemale || []) {
      const n = parseInt(item, 10);
      const adjacent =
        n % 2 === 0 ? (n - 1).toString() : (n + 1).toString();
      if (selectedSet.has(adjacent)) return false;
    }
  } else if (type === "female") {
    for (const item of reservedSeatsByMale || []) {
      const n = parseInt(item, 10);
      const adjacent =
        n % 2 === 0 ? (n - 1).toString() : (n + 1).toString();
      if (selectedSet.has(adjacent)) return false;
    }
  }

  return true;
}
